/* eslint-disable no-console */
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/app'
import 'firebase/auth'

import AlertCmp from './components/Shared Component/Alert.vue'
import AddBotDataDialog from './components/Companies/Edit/AddBotDataDialog.vue'
import EditCollab from './components/User/Components/EditCollab.vue'
import AddCollabDialog from './components/User/Components/AddCollabDialog.vue'
import EditCollabDialog from './components/User/Components/EditCollabDialog.vue'
import DateFilter from './filters/date'
import Gallery from './components/Shared Component/Gallery.vue'
import AddVariationImage from './components/Shared Component/AddVariationImage.vue'
import FlowComponents from './components/Shared Component/FlowComponents.vue'
import LoadingDialog from './components/Shared Component/Loading dialog.vue'
import LoadImageDialog from './components/Shared Component/LoadImageDialog.vue'
import LoadVideoDialog from './components/Shared Component/LoadVideoDialog.vue'
import LoadingCircular from './components/Shared Component/LoadingCircular.vue'
import LoadingMediaDialog from './components/Shared Component/LoadingMediaDialog.vue'
import OrderDialog from './components/Orders/Components/Order.vue'
import SignUp from './components/User/SignUpDialog.vue'
import SignIn from './components/User/SignInDialog.vue'

Vue.config.productionTip = false
Vue.filter('dateFilter', DateFilter)
Vue.component('app-alert', AlertCmp)
Vue.component('add-bot-data-dialog', AddBotDataDialog)
Vue.component('edit-collab', EditCollab)
Vue.component('add-collab-dialog', AddCollabDialog)
Vue.component('edit-collab-dialog', EditCollabDialog)
Vue.component('loading-dialog', LoadingDialog)
Vue.component('gallery', Gallery)
Vue.component('add-variation-image', AddVariationImage)
Vue.component('flow-components', FlowComponents)
Vue.component('load-image-dialog', LoadImageDialog)
Vue.component('load-video-dialog', LoadVideoDialog)
Vue.component('loading-circular', LoadingCircular)
Vue.component('loading-media-bar', LoadingMediaDialog)
Vue.component('order-dialog', OrderDialog)
Vue.component('sign-in-dialog', SignIn)
Vue.component('sign-up-dialog', SignUp)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    // Initialize firebase

    firebase.initializeApp({
      apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
    })

    firebase.auth().onAuthStateChanged(async (user) => {
      try {
        if (user) {
          const authUser = {
            name: user.displayName,
            email: user.email,
            photoUrl: user.photoURL,
            id: user.uid
          }
          console.log('authUser', user)
          await this.$store.dispatch('actionAutoSignIn', authUser)
        }
        console.log('end user authentication')
      } catch (error) {
        alert(error.message)
      }
    })
    // console.log = () => {}
  }
}).$mount('#app')
